import { apiSlice } from "../../../features/api/apiSlice";

/**
 * Membership Committee review of ENTRY (probationer) applications.
 *
 * The same committee and the same shape as the upgrade reviews next door:
 *   Member   → applications assigned to me + record a recommendation.
 *   Chairman → every application with its recommendation + the final decision.
 *
 * One reviewer per entry application, so each carries a single recommendation.
 */
export const committeeEntryReviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    myEntryReviews: builder.query<any[], void>({
      query: () => "/committee/my-entry-reviews",
      transformResponse: (res: any) => res?.data ?? [],
      providesTags: [{ type: "MyEntryReviews" as const, id: "LIST" }],
    }),

    decideEntryReview: builder.mutation<
      any,
      { id: string; decision: "approved" | "rejected"; remark?: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/committee/entry-reviews/${id}/decide`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "MyEntryReviews" as const, id: "LIST" },
        { type: "CommitteeEntryApps" as const, id: "LIST" },
      ],
    }),

    chairmanEntryApplications: builder.query<any[], void>({
      query: () => "/committee/entry-applications",
      transformResponse: (res: any) => res?.data ?? [],
      providesTags: [{ type: "CommitteeEntryApps" as const, id: "LIST" }],
    }),

    finalizeEntryApplication: builder.mutation<
      any,
      { id: string; decision: "approved" | "rejected"; remark?: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/committee/entry-applications/${id}/finalize`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "CommitteeEntryApps" as const, id: "LIST" },
        { type: "MyEntryReviews" as const, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useMyEntryReviewsQuery,
  useDecideEntryReviewMutation,
  useChairmanEntryApplicationsQuery,
  useFinalizeEntryApplicationMutation,
} = committeeEntryReviewApi;
